import { render } from "./grading-tab.vue?vue&type=template&id=d600c85a"
import script from "./grading-tab.vue?vue&type=script&lang=js"
export * from "./grading-tab.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__